function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
import WS from "isomorphic-ws";
var MAX_WS_RECONN_BACKOFF_MS = 32000; // 32 seconds
var MAX_WS_RECONN_TIME_MS = 2 * 60 * 1000; // 2 minutes
var WebSocket = /*#__PURE__*/ function() {
    "use strict";
    function WebSocket(uri, accessToken, heartbeatSignal) {
        var _this = this;
        _classCallCheck(this, WebSocket);
        this._handleSocketOpen = function() {
            var _this1 = _this;
            _this._connRetries = 0;
            _this._disconnectStart = 0;
            _this._setupHeartbeat();
            // console.log('sending ' + this._pendingMessages.length + ' pending messages');
            _this._pendingMessages.forEach(function(s) {
                _this1.send(s);
            });
            _this._pendingMessages = [];
            if (_this._onopen) _this._onopen(_this._reconnect);
        };
        this._handleSocketError = function(e) {
            if (_this._onerror) _this._onerror(e);
        };
        this._handleSocketClose = function(e) {
            var _this2 = _this;
            console.log("_handleSocketClose");
            _this._clearHeartbeat();
            if (_this._disconnectStart) {
                var now = new Date();
                if (now.getTime() - _this._disconnectStart >= MAX_WS_RECONN_TIME_MS) {
                    console.log("final disconnect");
                    if (_this._ondisconnect) _this._ondisconnect(false);
                    _this._disconnectStart = 0;
                    _this._connRetries = 0;
                    _this._reconnect = false;
                    return;
                }
            } else {
                _this._disconnectStart = new Date().getTime();
            }
            var jitter = Math.floor(Math.random() * 1000);
            var backoff = Math.min(Math.pow(2, _this._connRetries) + jitter, MAX_WS_RECONN_BACKOFF_MS);
            _this._connRetries++;
            _this._retryTimeout = setTimeout(function() {
                if (_this2._ondisconnect) _this2._ondisconnect(true);
                _this2._reinitWebSocket(_this2._uri);
            }, backoff);
            return;
        };
        this._connRetries = 0;
        this._disconnectStart = 0;
        this._reconnect = false;
        this._uri = uri;
        this._heartbeatInterval = null;
        this._heartbeatSignal = heartbeatSignal;
        this._retryTimeout = null;
        this._accessToken = accessToken;
        var wsProtos = [];
        if (this._accessToken) {
            wsProtos = [
                "Bearer%".concat(this._accessToken)
            ];
        }
        this.socket = new WS(uri, wsProtos);
        this._messageListeners = [];
        this._pendingMessages = [];
        this._setupEventListeners();
    }
    var _proto = WebSocket.prototype;
    _proto._setupEventListeners = function _setupEventListeners() {
        this.socket.addEventListener("open", this._handleSocketOpen);
        this.socket.addEventListener("error", this._handleSocketError);
        this.socket.addEventListener("close", this._handleSocketClose);
    };
    _proto._removeEventListeners = function _removeEventListeners() {
        var _this = this;
        this.socket.removeEventListener("open", this._handleSocketOpen);
        this.socket.removeEventListener("error", this._handleSocketError);
        this.socket.removeEventListener("close", this._handleSocketClose);
        this._messageListeners.forEach(function(onmessage) {
            _this.socket.removeEventListener("message", onmessage);
        });
    };
    _proto._reinitWebSocket = function _reinitWebSocket(uri) {
        var _this = this;
        this._removeEventListeners();
        var wsProtos = [];
        if (this._accessToken) {
            wsProtos = [
                "Bearer%".concat(this._accessToken)
            ];
        }
        this.socket = new WS(uri, wsProtos);
        this._messageListeners.forEach(function(onmessage) {
            _this.socket.addEventListener("message", onmessage);
        });
        this._reconnect = true;
        this._uri = uri;
        this._setupEventListeners();
    };
    _proto.addMessageListener = function addMessageListener(onmessage) {
        this._messageListeners.push(onmessage);
        this.socket.addEventListener("message", onmessage);
    };
    _proto.removeMessageListener = function removeMessageListener(onmessage) {
        this.socket.removeEventListener("message", onmessage);
    };
    _proto._clearHeartbeat = function _clearHeartbeat() {
        if (this._heartbeatInterval) {
            clearInterval(this._heartbeatInterval);
        }
    };
    _proto._setupHeartbeat = function _setupHeartbeat() {
        var _this = this;
        this._heartbeatInterval = setInterval(function() {
            if (!_this.socket) {
                console.error("no socket for heartbeat");
                return;
            }
            _this.send(_this._heartbeatSignal);
        }, 3000);
    };
    _proto.send = function send(s) {
        if (this.socket.readyState !== WS.OPEN) {
            // console.log(
            //     'send called in socket non open readystate',
            //     s.type,
            //     this.socket.readyState
            // );
            this._pendingMessages.push(s);
            return;
        }
        // console.log('sending message', s.type);
        this.socket.send(JSON.stringify(s));
    };
    _proto.close = function close() {
        this._clearHeartbeat();
        if (this._retryTimeout) {
            clearTimeout(this._retryTimeout);
        }
        this._removeEventListeners();
        this.socket.close();
    };
    _createClass(WebSocket, [
        {
            key: "onopen",
            set: function set(onopen) {
                if (this.socket.readyState === WS.OPEN) {
                    onopen(false);
                }
                this._onopen = onopen;
            }
        },
        {
            key: "onerror",
            set: function set(onerror) {
                this._onerror = onerror;
            }
        },
        {
            key: "ondisconnect",
            set: function set(ondisconnect) {
                this._ondisconnect = ondisconnect;
            }
        }
    ]);
    return WebSocket;
}();
export { WebSocket };
